import axios from 'axios';
import apiConfig from '../config/apiConfig';

/**
 * Base API instance with axios
 */
const api = axios.create({
    baseURL: apiConfig.baseUrl,
    timeout: apiConfig.timeout,
    headers: apiConfig.headers
});

/**
 * Request interceptor
 */
api.interceptors.request.use(
    (config) => {
        // You can modify config here before request is sent
        // For example, adding authentication tokens
        console.log(`Making API request to: ${config.baseURL}${config.url}`);
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

/**
 * Response interceptor
 */
api.interceptors.response.use(
    (response) => {
        // Any status code within the range of 2xx causes this function to trigger
        return response;
    },
    (error) => {
        // Handle API errors
        let errorMessage = 'An error occurred with the API request';

        if (error.response) {
            // The server responded with a status code outside of 2xx
            errorMessage = error.response.data?.message ||
                error.response.data?.error ||
                `Error ${error.response.status}: ${error.response.statusText}`;
        } else if (error.request) {
            // The request was made but no response was received
            errorMessage = 'No response received from the server. Please check your internet connection.';
        }

        console.error('API Error:', errorMessage, error);

        // Return a reject promise with the error
        return Promise.reject(error);
    }
);

export default api;